/** Stable id shared with VaulDrawer titleId so the FY dialog announces its visible heading. */
export const SELECT_FINANCIAL_YEAR_HEADING_ID = 'select-financial-year-heading'
